module.exports = __webpack_public_path__ + "img/onborad3.04c9eac8.png";